import { render, staticRenderFns } from "./TestDetail.vue?vue&type=template&id=7d36b479&"
import script from "./TestDetail.vue?vue&type=script&lang=ts&"
export * from "./TestDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports